import { env } from "@/constants/env";
import { supabase } from "@/lib/supabase";
import mixpanel from "mixpanel-browser";

export function initializeMixpanel() {
  if (!env.MIXPANEL_TOKEN) {
    console.warn("Mixpanel token is missing! Check your .env file.");
    return;
  }

  mixpanel.init(env.MIXPANEL_TOKEN, {
    autotrack: true,
    track_pageview: true,
  });
  supabase.auth.onAuthStateChange((_, session) => {
    if (session?.user) {
      mixpanel.identify(session.user.id);
      mixpanel.people.set({
        // mixpanel reserved properties
        $email: session.user.email,
        $name: session.user.user_metadata.name,

        // deprecated
        email: session.user.email,
        username: session.user.user_metadata.name,
      });
    }
  });
}
